import TechnologyDocument from './TechnologyDocument.vue'
export default TechnologyDocument



// WEBPACK FOOTER //
// ./src/pages/TechnologyDocument/index.js